import { useTranslation } from 'react-i18next';

import { ChangeButton, cn, FooterStyles, Images } from 'scbk-ui-web';

import { Modules, useConfig, useLocale, useMenuRouter } from 'scbk-services';
import { useChangeMode } from 'scbk-shared-module/modules/ComfyBank';

interface DesktopFooterProps {
  langBtn?: boolean;
}

const DesktopFooter = ({ langBtn = false }: DesktopFooterProps) => {
  const { t } = useTranslation();
  const { getLocale } = useLocale();
  const { getConfig } = useConfig();
  const { changeLocale } = useChangeMode();

  const homePageDomain = getConfig(Modules.COMMON).homePageDomain;

  const goPortalAscp = (url: string) => {
    console.log('### homePageDomain : ', homePageDomain);
    // `${homePageDomain}/3rdParty/portal_ascp.jsp?loginDt=&ascpURL=${url}&QueryString=&loginCheck=Y&certLogin=Y&toGB=ib&IBType=4&langCode=${getLocale().toUpperCase()}&secureData=`,

    location.href = `${homePageDomain}/${url}`;
  };

  const { goMenu } = useMenuRouter();

  const footerGoUrl = (val: string) => {
    if (val === '1') {
      //개인정보처리(취급)방침
      // goPortalAscpPop1(
      //   'https://www.standardchartered.co.kr/np/kr/cms/cm/cc/IndividualPolicyTreatment.jsp',
      // );
      goPortalAscp('/np/kr/cms/cm/cc/IndividualPolicyTreatment.jsp');
    } else if (val === '4') {
      //보호금융상품등록부
      goPortalAscp('/np/kr/cms/pl/se/ProtectSystem.jsp');
    } else if (val === '5') {
      //상품공시실
      goPortalAscp('/np/kr/cms/cm/cc/Cont001.jsp');
    } else if (val === '8') {
      //고객컨택센터 1588-1599
      goPortalAscp('/np/kr/cm/cc/ContactCenterInfo.jsp');
    } else if (val === '11') {
      //공시
      if (getLocale() === 'en') {
        goPortalAscp('/np/en/cms/cm/bi/EnRatinginfo.jsp');
      } else {
        goPortalAscp('/np/kr/cms/cm/bi/CreditGradeList.jsp');
      }
    } else if (val === '14') {
      //스탠다드차타드그룹
      window.open('http://www.standardchartered.com/home/en/index.html');
    } else if (val == '20') {
      //전자민원창구
      if (getLocale() === 'en') {
        goPortalAscp('/np/en/cm/cc/EnVoiceOfCustomer.jsp');
      } else {
        goPortalAscp('/np/kr/cm/cc/VoiceOfCustomer.jsp');
      }
    } else if (val === '28') {
      //신용정보활용체제
      window.open(`${homePageDomain}/np/kr/cms/cm/cc/CreditInfoUseSystem.jsp`);
    } else if (val === '29') {
      //웹 접근성
      window.open('http://www.wa.or.kr/');
    } else if (val === '30') {
      // 금융사기예방안내
      goPortalAscp(`/np/kr/cms/cm/cc/FinanceBoard.jsp`);
    } else if (val === '31') {
      goMenu('SVCSUP003');
    }
  };

  return (
    <footer className={FooterStyles['desktop-footer-wrap']}>
      {/* 왼쪽 s */}
      <div className={FooterStyles['desktop-footer-layout']}>
        <div className="">
          <div className="flex flex-row gap-6">
            <button
              title={t('Layout.DesktopFooter.001', {
                defaultValue: '개인정보처리방침 페이지로 이동',
              })}
              className={cn(FooterStyles['link-txt'], 'text-basic-01')}
              onClick={() => {
                footerGoUrl('1');
              }}
            >
              {t('Layout.DesktopFooter.002', { defaultValue: '개인정보처리방침' })}
            </button>
            <button
              title={t('Layout.DesktopFooter.003', {
                defaultValue: '신용정보활용체제 페이지로 이동',
              })}
              className={cn(FooterStyles['link-txt'], 'text-basic-01')}
              onClick={() => {
                footerGoUrl('28');
              }}
            >
              {t('Layout.DesktopFooter.004', { defaultValue: '신용정보활용체제' })}
            </button>
            <button
              title={t('Layout.DesktopFooter.005', { defaultValue: '전자민원 페이지로 이동' })}
              className={cn(FooterStyles['link-txt'], '!text-primary-04')}
              onClick={() => {
                footerGoUrl('20');
              }}
            >
              {t('Layout.DesktopFooter.006', { defaultValue: '전자민원' })}
            </button>
            <button
              title={t('Layout.DesktopFooter.007', { defaultValue: '상품공시실 페이지로 이동' })}
              className={cn(FooterStyles['link-txt'], 'text-basic-01')}
              onClick={() => {
                footerGoUrl('5');
              }}
            >
              {t('Layout.DesktopFooter.008', { defaultValue: '상품공시실' })}
            </button>
          </div>
          <div className="flex flex-row gap-6 mt-2">
            <button
              title={t('Layout.DesktopFooter.009', {
                defaultValue: '스탠다드차타드그룹 페이지로 이동',
              })}
              className={cn(FooterStyles['link-txt'], 'text-basic-04')}
              onClick={() => {
                footerGoUrl('14');
              }}
            >
              {t('Layout.DesktopFooter.010', { defaultValue: '스탠다드차타드그룹' })}
            </button>
            <button
              title={t('Layout.DesktopFooter.011', { defaultValue: '은행공시 페이지로 이동' })}
              className={cn(FooterStyles['link-txt'], 'text-basic-04')}
              onClick={() => {
                footerGoUrl('11');
              }}
            >
              {t('Layout.DesktopFooter.012', { defaultValue: '은행공시' })}
            </button>
            <button
              title={t('Layout.DesktopFooter.013', {
                defaultValue: '보호금융상품등록부 페이지로 이동',
              })}
              className={cn(FooterStyles['link-txt'], 'text-basic-04')}
              onClick={() => {
                footerGoUrl('4');
              }}
            >
              {t('Layout.DesktopFooter.014', { defaultValue: '보호금융상품등록부' })}
            </button>
            <button
              title={t('Layout.DesktopFooter.015', {
                defaultValue: '금융사기예방안내 페이지로 이동',
              })}
              className={cn(FooterStyles['link-txt'], 'text-basic-04')}
              onClick={() => {
                footerGoUrl('30');
              }}
            >
              {t('Layout.DesktopFooter.016', { defaultValue: '금융사기예방안내' })}
            </button>
            <button
              title={t('Layout.DesktopFooter.023', { defaultValue: '이용시간 안내 페이지로 이동' })}
              className={cn(FooterStyles['link-txt'], 'text-basic-04')}
              onClick={() => {
                footerGoUrl('31');
              }}
            >
              {t('Layout.DesktopFooter.022', {
                defaultValue: '이용시간 안내',
              })}
            </button>
          </div>
          <address className="mt-8 not-italic text-basic-04 font-weight-medium body-md">
            {t('Layout.DesktopFooter.017', {
              defaultValue: '031160 서울특별시 종로구 종로 47 (공평동 100) SC제일은행 본점',
            })}
            <span
              className="ml-4"
              onClick={() => {
                footerGoUrl('8');
              }}
            >
              {t('Layout.DesktopFooter.018', { defaultValue: '고객컨택센터' })}{' '}
              <strong className="eng-body-xxm font-weight-medium">1588-1599</strong>
            </span>
          </address>
          <small className="mt-2 eng-body-sm text-basic-04 font-weight-medium">
            COPYRIGHT &copy; 2025 Standard Chartered Bank Korea Limited.
          </small>
        </div>
        {/* 왼쪽 e */}
        {/* 오른쪽 s */}
        <div className="flex flex-col justify-start">
          <div className="ml-auto">
            {langBtn && (
              <ChangeButton
                onClick={changeLocale}
                textLang={t('Layout.ChangeButton.001', {
                  defaultValue: '한국어',
                })}
              />
            )}
          </div>
          <div className="flex flex-row mt-auto">
            <button
              title={t('Layout.DesktopFooter.019', {
                defaultValue: '한국정보접근성인증평가원 새 창 열림',
              })}
              className=""
              onClick={() => {
                footerGoUrl('29');
              }}
            >
              <span className="block w-[83px] h-[54px]">
                <img
                  src={Images.ImgWa}
                  alt={t('Layout.DesktopFooter.020', {
                    defaultValue: '과학기술정보통신부 WA/WEB접근성 한국 정보접근성인증평가원',
                  })}
                />
              </span>
            </button>
            <span className="block w-[107px] h-[54px] ml-4">
              <img
                src={Images.ImgFooterBanner}
                alt={t('Layout.DesktopFooter.021', { defaultValue: 'KSQI 인증마크' })}
              />
            </span>
          </div>
        </div>
        {/* 오른쪽 e */}
      </div>
    </footer>
  );
};

export { DesktopFooter };
